import React, { useEffect, useMemo, useState } from 'react';
import AccountCampaignMenubar from '../components/account-campaign-menubar';
import { useGetAccountsQuery } from '../endpoints/accounts.endpoints';
import { useGetCompaniesQuery } from 'src/pages/billing/endpoints/billing.endpoints';
import AccountTable from '../components/account-table';
import ManageListPagination from '../components/manage-list-pagination';
import { useManageListUrlParams } from '../hooks/use-manage-list-url-params';

const ManageAccountsTab: React.FC = () => {
  const { filter, searchQuery, setFilterWithUrl, setSearchWithUrl } = useManageListUrlParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);

  const { data: companies = [] } = useGetCompaniesQuery();

  const queryArgs = useMemo(
    () => ({
      page,
      page_size: pageSize,
      search: searchQuery.trim() || undefined,
      attention_needed: filter === 'attention_needed' ? true : undefined,
    }),
    [page, pageSize, searchQuery, filter]
  );

  const { data, isFetching, isLoading, refetch } = useGetAccountsQuery(queryArgs);

  const accounts = data?.items ?? [];
  const totalObjects = data?.total_objects ?? 0;
  const totalPages = data?.total_pages ?? 0;

  useEffect(() => {
    setPage(1);
  }, [searchQuery, filter, pageSize]);

  const handleCompanySelect = () => {
    refetch();
  };

  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
  };

  return (
    <div className="h-full w-full flex flex-col space-y-4 pt-0 min-h-0">
      <AccountCampaignMenubar
        label="Accounts"
        items={accounts}
        className="bg-gray-201 text-black rounded-full"
        selectedFilter={filter}
        filterSelect={setFilterWithUrl}
        searchQuery={searchQuery}
        searchChange={setSearchWithUrl}
        searchPlaceholder="Search by title…"
      />

      <div className="flex flex-col flex-1 min-h-0 rounded-lg border border-gray-200 overflow-hidden">
        <AccountTable
          accounts={accounts}
          companies={companies}
          onCompanySelect={handleCompanySelect}
          className="flex-1 min-h-0"
          isRefreshing={isLoading || isFetching}
        />
        <ManageListPagination
          page={page}
          totalPages={totalPages}
          totalObjects={totalObjects}
          pageSize={pageSize}
          onPageChange={setPage}
          onPageSizeChange={handlePageSizeChange}
          disabled={isFetching}
        />
      </div>
    </div>
  );
};

export default ManageAccountsTab;
